/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { LocaleContext } from '../../contexts/locale/index'
import { useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { MunicipalitySelection } from 'components/municipalitySelection'
import { Article } from 'components/article'
import LOCALES from './locales.js'
import standaloneConfig from '../../../.taStandalonerc.yml'

const frenchTenants = ['24heures', 'tdg', 'lematin']
const isFrenchTenant = frenchTenants.includes(parseHostname().publicationName)
const locale = isFrenchTenant ? 'fr' : 'de'
const ARTICLE_ID = standaloneConfig.articleId[locale]

export function AppComponent() {
  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }
  const history = useHistory()
  const municipalityId = useQuery().get('municipality')
  const handleMunicipalitySelection = ({ GDENR }: { GDENR: number }) => {
    const municipalityId = GDENR

    // Analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `select_municipality:${municipalityId}`
    })

    // const moveGoal = config.routes.article + municipalityId
    history.push('?municipality=' + municipalityId)
  }

  useEffect(() => {
    console.log('New municipality:', municipalityId)
  }, [municipalityId])

  return (
    <LocaleContext.Provider value={locale}>
      <Helmet>
        <html lang={locale + '-CH'} />
      </Helmet>

      <div className='index' id='main-content'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        {municipalityId ? (
          <>
            <Article
              onMunicipalitySelection={handleMunicipalitySelection}
              municipalityId={municipalityId}
            />
          </>
        ) : (
          <>
            <header className='ui vertical  very fitted  segment'>
              <div className='ui container'>
                <div className='ui header'>
                  <h1>{LOCALES.title[locale]}</h1>
                  <h2>{LOCALES.lead[locale]}</h2>
                </div>
              </div>
            </header>
            <div className='ui vertical colored very padded segment'>
              <div className='ui text container'>
                <MunicipalitySelection
                  locale={locale}
                  onMunicipalitySelection={handleMunicipalitySelection}
                />
              </div>
            </div>
          </>
        )}

        <div className='ui grey secondary vertical segment' id='methodik'>
          <div className='ui text container'>
            <h2 className='ui infographic small grey header'>
              <i className='blue info circle icon' />
              <div className='content'>{LOCALES.methodology.title[locale]}</div>
            </h2>
            <div>{LOCALES.methodology.text[locale]}</div>
          </div>
        </div>

        <Footer
          title={LOCALES.feedback.title[locale]}
          questions={LOCALES.feedback.questions[locale]}
          mailTo='atm@tamedia.ch'
          hidePortfolioTeaser
          articleId={ARTICLE_ID}
          credits={LOCALES.credits[locale]}
        />
      </div>
    </LocaleContext.Provider>
  )
}
